import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {disaggregationType$, disaggregationTypeChanged, stepChanged} from 'models/documents/create';
import {DisaggregationType} from 'types';

import {NextAction, TypeField, TypeLabel, TypeOption, TypeOptions, TypeStep} from './styled';

const DISAGGREGATION_TYPES: DisaggregationType[] = ['TRANSPORT_PACKAGING', 'GROUP_PACKAGING'];

export const DisaggregationTypeStep = () => {
    const {t} = useTranslation();
    const disaggregationType = useStore(disaggregationType$);

    return (
        <TypeStep>
            <TypeField>
                <TypeLabel>
                    {t('pages.documents.disaggregation.typeLabel')} <span>*</span>
                </TypeLabel>
                <TypeOptions
                    role="radiogroup"
                    aria-label={t('pages.documents.disaggregation.typeLabel')}
                >
                    {DISAGGREGATION_TYPES.map((type) => {
                        const selected = disaggregationType === type;

                        return (
                            <TypeOption
                                key={type}
                                type="button"
                                role="radio"
                                aria-checked={selected}
                                selected={selected}
                                onClick={() => {
                                    if (!selected) disaggregationTypeChanged(type);
                                }}
                            >
                                {t(`pages.documents.disaggregation.types.${type}`)}
                            </TypeOption>
                        );
                    })}
                </TypeOptions>
            </TypeField>
            <NextAction>
                <Button
                    style={{width: 'auto'}}
                    variant={ButtonVariant.Normal}
                    type="button"
                    onClick={() => stepChanged(1)}
                >
                    {t('components.form.nextStep')}
                </Button>
            </NextAction>
        </TypeStep>
    );
};
